import { useParams, NavLink } from 'react-router-dom';
import { getTranslate } from '../../../utils/getTranslate/getTranslate';
import { getLocalPath } from '../../../utils/getLocatPath/getLocalPath';
import { upBooks } from '../data/books';
import styles from '../Home.module.scss';

export const Fullscreen = ({ upPage }) => {
  const t = getTranslate;
  const l = getLocalPath;
  const { lang } = useParams();
  const { fullscreen } = upPage.acf;
  const { text_one, text_two, title, text, numbers, marquee } = fullscreen;
  const { books, users, years } = numbers;

  return (
    <section className={styles.fullscreen}>
      <div className="container">
        <div className={styles.fullscreen_body}>
          <div className={styles.fullscreen_wallpaper}>
            <div className={styles.fullscreen_wallpaper_body}>
              <div className={`${styles.fullscreen_wallpaper_icon} one`}>🦋</div>
              <div className={`${styles.fullscreen_wallpaper_icon} two`}>📗</div>
              <div className={`${styles.fullscreen_wallpaper_icon} three`}>⭐</div>
              <div className={`${styles.fullscreen_wallpaper_icon} four`}>🏛️</div>
            </div>
          </div>
          <div className={styles.fullscreen_row}>
            <div className={styles.fullscreen_info}>
              <p className={styles.fullscreen_info_title_one}>{text_one[lang]}</p>
              <p className={styles.fullscreen_info_title_two}>{text_two[lang]}</p>
              <h1 className={styles.fullscreen_info_title_main}>{title[lang]}</h1>
              <p className={styles.fullscreen_info_text}>{text[lang]}</p>
              <div className={styles.fullscreen_info_row}>
                <NavLink to={l('', lang)} className={styles.fullscreen_info_link_one}>
                  {t('📚 Зерттеу', '📚 Исследовать', lang)}
                </NavLink>
                <NavLink to={l('', lang)} className={styles.fullscreen_info_link_two}>
                  {t('📍 Бізді қалай табуға болады', '📍 Как нас найти', lang)}
                </NavLink>
              </div>
              <div className={styles.fullscreen_info_num}>
                <div className={styles.fullscreen_info_num_column}>
                  <div className={styles.fullscreen_info_num_column_num}>{books}</div>
                  <div className={styles.fullscreen_info_num_column_text}>{t('Кітап', 'Книг', lang)}</div>
                </div>
                <div className={styles.fullscreen_info_num_column}>
                  <div className={styles.fullscreen_info_num_column_num}>{users}</div>
                  <div className={styles.fullscreen_info_num_column_text}>{t('Оқырман/жыл', 'Читателей/год', lang)}</div>
                </div>
                <div className={styles.fullscreen_info_num_column}>
                  <div className={styles.fullscreen_info_num_column_num}>{years}</div>
                  <div className={styles.fullscreen_info_num_column_text}>{t('Жыл сізбен', 'Лет с вами', lang)}</div>
                </div>
              </div>
            </div>
            <div className={styles.fullscreen_book}>
              <div className={styles.fullscreen_book_row}>
                {upBooks.map((el, idx) => {
                  const { icon, category, title, img_url, link_url } = el;
                  return (
                    <div key={idx} className={styles.fullscreen_book_column}>
                      <NavLink to={l(link_url, lang)} className={styles.fullscreen_book_column_body}>
                        <div className={styles.fullscreen_book_column_img}>
                          <img src={img_url} alt={title[lang]} />
                        </div>
                        <div className={styles.fullscreen_book_column_content}>
                          <div
                            className={styles.fullscreen_book_column_category}
                          >{`${icon} ${category.map((el) => el[lang]).slice(0, 1)}`}</div>
                          <div className={styles.fullscreen_book_column_title}>{title[lang]}</div>
                          <div className={styles.fullscreen_book_column_btn}>{t('Ашу →', 'Открыть →', lang)}</div>
                        </div>
                      </NavLink>
                    </div>
                  );
                })}
              </div>
            </div>
          </div>
          <div className={styles.fullscreen_marquee}>
            <div className={styles.fullscreen_marquee_row}>
              {marquee.map((el, idx) => {
                return (
                  <div key={idx} className={styles.fullscreen_marquee_item}>
                    {el[lang]}
                  </div>
                );
              })}
            </div>
            <div className={styles.fullscreen_marquee_row}>
              {marquee.map((el, idx) => {
                return (
                  <div key={idx} className={styles.fullscreen_marquee_item}>
                    {el[lang]}
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
